import React, { useState } from "react";
import {
  Card,
  Checkbox,
  Button,
  Typography,
  Modal,
  Spin,
  message,
  Row,
  Col,
  Input,
  Form,
} from "antd";
import { CbdtApiService } from "../../cbdtService";
import { useParams } from "react-router-dom";
import "./index.css";
const { Text, Link } = Typography;

const PaymentCard = (props) => {
  const [isChecked, setIsChecked] = useState(false);
  const [form] = Form.useForm();
  const [isGstChecked, setIsGstChecked] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    mobile: "",
    email: "",
  });
  const [error, setError] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  let { transaction_id } = useParams();
  const [payloader, setPayloader] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
    setError(false);
    if (e.target.checked) {
      setIsModalVisible(false);
    }
  };

  const handleGstCheckboxChange = (e) => {
    setIsGstChecked(e.target.checked);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handlePaymentClick = async () => {
    const mobileNumberRegex = /^[6-9]\d{9}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const { mobile, email } = formData;

    if (!isChecked) {
      setError(true);
    } else {
      if (isGstChecked) {
        try {
          await form.validateFields();
          if (!mobileNumberRegex.test(mobile)) {
            message.error("Enter a valid 10-digit mobile number.");
            return;
          }
          if (!emailRegex.test(email)) {
            message.error("Enter a valid email address.");
            return;
          }
          pay_amount_backend();
        } catch (errorInfo) {
          console.error("Validation Failed:", errorInfo);
          message.error("Please fill out all the required fields correctly.");
        }
      } else {
        pay_amount_backend();
      }
    }
  };
  const pay_amount_backend = async () => {
    setPayloader(true);
    const queryData = {
      txnid: transaction_id,
      isChecked: isChecked,
      ...form.getFieldsValue(),
    };
    const response = await CbdtApiService.pay(queryData);
    if (response.status) {
      window.open(response.data?.redirect_url, "_self");
      setPayloader(false);
    } else {
      window.open(response?.redirect_url, "_self");
      setPayloader(false);
    }
    setPayloader(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const gstInvoiceDetails = () => {
    return (
      <Form form={form} layout="vertical" className="gst-form custom-form-item">
        <Form.Item
          label={
            <>
              <span>Company Registered Name</span>
            </>
          }
          name="name"
          rules={[
            { required: true, message: "Enter company registered name." },
          ]}
        >
          <Input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Your Name"
          />
        </Form.Item>
        <Form.Item
          label={
            <>
              <span>Company Registered Address</span>
            </>
          }
          name="address"
          rules={[
            { required: true, message: "Enter company registered address." },
          ]}
        >
          <Input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            placeholder="Your Address"
          />
        </Form.Item>
        <Form.Item
          label={
            <>
              <span>Registered Mobile Number</span>
            </>
          }
          name="mobile"
          rules={[{ required: true, message: "Enter mobile number." }]}
        >
          <Input
            type="text"
            name="mobile"
            value={formData.mobile}
            onChange={handleInputChange}
            placeholder="Your mobile number"
          />
        </Form.Item>
        <Form.Item
          label={
            <>
              <span>Registered Email</span>
            </>
          }
          name="email"
          rules={[{ required: true, message: "Enter email address." }]}
        >
          <Input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Your Email"
          />
        </Form.Item>
      </Form>
    );
  };

  return (
    <>
      <Card className="card-align-right card-align-padding cbdt-custom-card">
        <span className="card-title-heading"> Payment Options</span>

        <div className="payment-image-wrapper">
          <img
            src={
              props?.transaction_data?.type == "upi"
                ? "https://ebz-static.s3.ap-south-1.amazonaws.com/layer/upi.svg"
                : "https://ebz-static.s3.ap-south-1.amazonaws.com/layer/ion_card-outline.svg"
            }
          ></img>
          <span className="payment-label">
            {props?.transaction_data?.type === "upi" ? "UPI" : "Cards"}
          </span>
        </div>

        <div className="top-bar-margin">
          <Checkbox
            className="custom-checkbox"
            checked={isGstChecked}
            onChange={handleGstCheckboxChange}
          >
            <span className="accept-all-title">
              {" "}
              Receive the GST invoice for PG Service charge
            </span>
          </Checkbox>
          <br></br>
          <span className="payment-achnowledgement">
            To receive the payment acknowledgment, please provide your details
          </span>
        </div>

        {isGstChecked && gstInvoiceDetails()}
        <div className="terms-wrapper">
          <Checkbox
            className="custom-checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          >
            <span className="accept-all-title"> I Accept all </span>
          </Checkbox>
          <Link className="link-color" onClick={showModal}>
            Terms & Conditions
          </Link>
          <span className="mandatory-mark"> *</span>
        </div>
        {error && (
          <Text type="danger" style={{ fontWeight: 500 }}>
            Please accept terms and conditions to proceed
          </Text>
        )}
        <Button
          className="pay-with-easebuzz-button"
          type="primary"
          block
          onClick={handlePaymentClick}
          disabled={payloader}
        >
          {payloader ? <Spin size="small" /> : "Complete Payment"}
        </Button>
      </Card>

      <div className="top-bar">
        <div className="top-bar-margin">
          <Checkbox
            className="custom-checkbox"
            checked={isGstChecked}
            onChange={handleGstCheckboxChange}
          >
            <span className="accept-all-title">
              {" "}
              Receive the GST invoice for PG Service charge
            </span>
          </Checkbox>
          <br></br>
          <span className="payment-achnowledgement">
            To receive the payment acknowledgment, please provide your details
          </span>
        </div>

        {isGstChecked && gstInvoiceDetails()}
        <Checkbox
          className="custom-checkbox"
          checked={isChecked}
          onChange={handleCheckboxChange}
        >
          <span className="accept-all-title"> I Accept all</span>
        </Checkbox>
        <Link className="link-color" onClick={showModal}>
          Terms & Conditions
        </Link>
        <span className="mandatory-mark"> *</span>

        <br></br>
        {error && (
          <>
            <Text type="danger" style={{ fontWeight: 500 }}>
              Please accept terms and conditions to proceed
            </Text>
            <br></br>
          </>
        )}
        <br></br>
        <Row className="payment-options-row">
          <Col span={12} style={{ display: "flex", flexDirection: "column" }}>
            <>
              <span className="card-title-heading"> Payment Options</span>
              <div className="payment-image-wrapper-mobile">
                <img
                  className="small-payment-image"
                  src={
                    props?.transaction_data?.type == "upi"
                      ? "https://ebz-static.s3.ap-south-1.amazonaws.com/layer/upi.svg"
                      : "https://ebz-static.s3.ap-south-1.amazonaws.com/layer/ion_card-outline.svg"
                  }
                ></img>
                <span className="payment-label">
                  {props?.transaction_data?.type === "upi" ? "UPI" : "Cards"}
                </span>
              </div>
            </>
          </Col>
          <Col span={12}>
            <Button
              className="pay-with-easebuzz-button"
              type="primary"
              block
              onClick={handlePaymentClick}
              disabled={payloader}
            >
              {payloader ? <Spin size="small" /> : "Complete Payment"}
            </Button>
          </Col>
        </Row>
      </div>

      <Modal
        title="Terms & Conditions"
        visible={isModalVisible}
        footer={null}
        onCancel={() => setIsModalVisible(false)}
        width={850}
        centered
      >
        <div>
          <div className="terms-and-condition-scroll">
            <p>
              These Terms and Conditions apply to all users of services offered
              by Union Bank of India for making payments through the online
              payment gateway. By using these services, each user acknowledges
              that they have read, understood, and accepted the Terms and
              Conditions outlined here.
            </p>
            <ul>
              <li>
                In order to verify the payment status the Taxpayer/User can
                Click on Trace Payment status link on the GST Common Portal for
                Home page. Enter the CPIN to know the status of payment.
              </li>
              <li>
                In case of FAILED CPIN status and the challan amount has been
                debited from the bank account, the Taxpayer/User is requested to
                wait for 24 hours. GST Common Portal will reconcile the CPIN
                with bank and update the status accordingly. Even after 24 hours
                if the payment status is FAILED, grievance should be raised with
                details on GST Common Portal.
              </li>
              <li>
                The Challan Identification Number receipt will be generated
                after the acknowledgement of the challan amount by the bank to
                GST Common Portal.
              </li>
            </ul>
            <p>
              Taxpayer/User shall file missing payment Form GST PMT-7 for the
              payments against CPIN where Cash Ledger has not been credited but
              payment has been debited. In case of any help, please write to
              helpdesk@gst.gov.in quoting the CPIN.
            </p>
            <p>Any fraudulent transaction or misuse can invite Legal action.</p>
          </div>
          <Checkbox
            className="custom-checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          >
            <span className="accept-all-terms-and-condition-modal">
              {" "}
              I Accept all Terms & Conditions{" "}
            </span>
          </Checkbox>
        </div>
      </Modal>
    </>
  );
};

export default PaymentCard;
